// custom icons
import * as FanHeadBlue from "./custom/fan-head-blue.json";
import * as FanHeadRed from "./custom/fan-head-red.json";

// regular
import * as HeatingRoom from "./default/regular/default/wired-outline-1610-heating-room.json";
import * as HeatingRadiator from "./default/regular/default/wired-outline-1611-heating-radiator.json";
import * as Heating from "./default/regular/default/wired-outline-1628-adjust-heating.json";
import * as GraphChart from "./default/regular/default/wired-outline-163-graph-line-chart.json";
import * as OpenWindow from "./default/regular/default/wired-outline-1636-open-window.json";
import * as CeilingFan from "./default/regular/default/wired-outline-1664-ceiling-fan.json";
import * as FanDefault from "./default/regular/default/wired-outline-1723-fan.json";
import * as FanHead from "./default/regular/default/wired-outline-1744-fan-head.json";
import * as CircleAvatar from "./default/regular/default/wired-outline-44-avatar-user-in-circle.json";
import * as Thermometer from "./default/regular/default/wired-outline-442-thermometer.json";
import * as Plug from "./default/regular/default/wired-outline-452-plug-in-electricity.json";
import * as AirConditioner from "./default/regular/default/wired-outline-821-airconditioner.json";

// regular minifyed
import * as HeatingRoomMin from "./default/regular/minify/wired-outline-1610-heating-room.json";
import * as HeatingRadiatorMin from "./default/regular/minify/wired-outline-1611-heating-radiator.json";
import * as HeatingMin from "./default/regular/minify/wired-outline-1628-adjust-heating.json";
import * as GraphChartMin from "./default/regular/minify/wired-outline-163-graph-line-chart.json";
import * as OpenWindowMin from "./default/regular/minify/wired-outline-1636-open-window.json";
import * as CeilingFanMin from "./default/regular/minify/wired-outline-1664-ceiling-fan.json";
import * as FanDefaultMin from "./default/regular/minify/wired-outline-1723-fan.json";
import * as FanHeadMin from "./default/regular/minify/wired-outline-1744-fan-head.json";
import * as CircleAvatarMin from "./default/regular/minify/wired-outline-44-avatar-user-in-circle.json";
import * as ThermometerMin from "./default/regular/minify/wired-outline-442-thermometer.json";
import * as PlugMin from "./default/regular/minify/wired-outline-452-plug-in-electricity.json";
import * as AirConditionerMin from "./default/regular/minify/wired-outline-821-airconditioner.json";

export {
    AirConditioner,
    AirConditionerMin,
    CeilingFan,
    CeilingFanMin,
    CircleAvatar,
    CircleAvatarMin,
    FanDefault,
    FanDefaultMin,
    FanHead,
    FanHeadBlue,
    FanHeadMin,
    FanHeadRed,
    GraphChart,
    GraphChartMin,
    Heating,
    HeatingMin,
    HeatingRadiator,
    HeatingRadiatorMin,
    HeatingRoom,
    HeatingRoomMin,
    OpenWindow,
    OpenWindowMin,
    Plug,
    PlugMin,
    Thermometer,
    ThermometerMin,
};
